$('a[href="#vg-nav-sidebar"]').click(function () {
	let $container = $("#main-sidebar-categories");
	let loaded = $container.data('loaded');

	if (!loaded) {
		$.get('/catalog/_mobile_nav', {}, function (data) {
			$container.find('.catalog-categories--clone').html(data.view);
			$container.data('loaded', true);
		})
	}
});
